<div class="get-started">
	<h2>Get Started</h2>
	<button (click)="scrollToTarget()">SCHEDULE A DEMO</button>
</div>

<div class="logo-carousel-container">
	<h1>Trusted by</h1>
	<div class="logo-carousel">
		<div class="logo-track">
			<img *ngFor="let logo of logos" [src]="logo" alt="Company Logo" class="logo" />
			<img *ngFor="let logo of logos" [src]="logo" alt="Company Logo" class="logo" />
			<img *ngFor="let logo of logos" [src]="logo" alt="Company Logo" class="logo" />
		</div>
	</div>
</div>
